'use strict';

exports.__esModule = true;
var CLINICS = exports.CLINICS = {
  LOAD: 'CLINICS_LOAD',
  LOAD_DONE: 'CLINICS_LOAD_DONE',
  LOAD_FAIL: 'CLINICS_LOAD_FAIL'
};

var BRANCH_DETAILS = exports.BRANCH_DETAILS = {
  LOAD: 'BRANCH_DETAILS_LOAD',
  SUCCESS: 'BRANCH_DETAILS_SUCCESS',
  FAIL: 'BRANCH_DETAILS_FAIL'
};

var BRANCH_FILTER = exports.BRANCH_FILTER = {
  SET_BRANCH_KEY: 'SET_BRANCH_KEY'
};

var setFilteredBranchKey = exports.setFilteredBranchKey = function setFilteredBranchKey(branchKey) {
  return {
    type: BRANCH_FILTER.SET_BRANCH_KEY,
    branchKey: branchKey
  };
};

var loadClinics = exports.loadClinics = function loadClinics(language) {
  return {
    type: CLINICS.LOAD,
    language: language
  };
};

var loadClinicsDone = exports.loadClinicsDone = function loadClinicsDone(clinics) {
  return {
    type: CLINICS.LOAD_DONE,
    clinics: clinics
  };
};

var loadClinicsFail = exports.loadClinicsFail = function loadClinicsFail(err) {
  return {
    type: CLINICS.LOAD_FAIL,
    err: err
  };
};

var getBranchDetails = exports.getBranchDetails = function getBranchDetails(branchKey) {
  return {
    type: BRANCH_DETAILS.LOAD,
    branchKey: branchKey
  };
};

var getBranchDetailsSuccess = exports.getBranchDetailsSuccess = function getBranchDetailsSuccess(payload) {
  return {
    type: BRANCH_DETAILS.SUCCESS,
    payload: payload
  };
};

var getBranchDetailsFail = exports.getBranchDetailsFail = function getBranchDetailsFail(payload) {
  return {
    type: BRANCH_DETAILS.FAIL,
    payload: payload
  };
};